import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Spin, Alert } from 'antd';
import { UserOutlined, LockOutlined, WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setLoginError(null);
      await authService.login(values.email, values.password);
      message.success('Login successful');
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);

      if (!error.response && error.message === 'Network Error') {
        setLoginError({
          type: 'error',
          message: 'Unable to connect',
          description: 'Please check your internet connection and try again.'
        });
      } else if (error.response?.status === 423) {
        // Account locked (HTTP 423 Locked)
        setLoginError({
          type: 'warning',
          message: 'Account Locked',
          description: error.response?.data?.detail || 'Your account has been temporarily locked due to too many failed login attempts. Please try again later or contact an administrator to unlock your account.'
        });
      } else if (error.response?.status === 401) {
        // Wrong credentials - show remaining attempts info from detail message
        const detail = error.response?.data?.detail || 'Incorrect email or password';
        if (detail.includes('attempt')) {
          setLoginError({
            type: 'warning',
            message: 'Login Failed',
            description: detail
          });
        } else {
          setLoginError({
            type: 'error',
            message: 'Login Failed',
            description: detail
          });
        }
      } else {
        setLoginError({
          type: 'error',
          message: 'Login Failed',
          description: error.response?.data?.detail || 'An unexpected error occurred. Please try again.'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f0f2f5' 
    }}>
      <Card title="Vendor Cost Optimization" style={{ width: 400 }}>
        <Spin spinning={loading}>
          {loginError && (
            <Alert
              type={loginError.type}
              message={loginError.message}
              description={loginError.description}
              showIcon
              icon={loginError.type === 'warning' ? <WarningOutlined /> : undefined}
              style={{ marginBottom: 16 }}
              closable
              onClose={() => setLoginError(null)}
            />
          )}
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Email" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Log in
              </Button>
            </Form.Item>
            
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default Login;